import { Group, Select } from "@mantine/core";
import { DateTime } from "luxon";
import { MONTH_CHOICES } from "../../../../../utils/dates";
import { backendDateOrDateTimeToLuxonDateTimeOrNull } from "../../../../../utils/dates/backendDateOrDateTimeToLuxonDateTimeOrNull";
import { luxonDateTimeToBackendDateOrDateTime } from "../../../../../utils/dates/luxonDateTimeToBackendDateOrDateTime";
import { getDayChoicesFromDays } from "./utils/getDayChoicesFromDays";
import { getDaysOfMonth } from "./utils/getDaysOfMonth";

interface DayInYearInputProps {
  error?: string;
  value?: string | null;
  onChange: (date: string | null) => void;
}

function DayInYearInput({ error, value, onChange }: DayInYearInputProps) {
  const dateFromValue = backendDateOrDateTimeToLuxonDateTimeOrNull(
    value ?? null
  );
  const dayValue = dateFromValue ? dateFromValue.day : null;
  const monthValue = dateFromValue ? dateFromValue.month : null;

  const dayChoices = getDayChoicesFromDays(getDaysOfMonth(monthValue ?? 1));
  const dayChoice = dayChoices.find(
    (choice) => choice.value === dayValue?.toString()
  )?.value;
  const monthChoice = MONTH_CHOICES.find(
    (choice) => choice.value === monthValue?.toString()
  )?.value;

  function handleChangeDay(value: number) {
    if (value <= 31 && value >= 1) {
      const newDate = DateTime.local(2023, monthValue ?? 1, value);
      onChange(luxonDateTimeToBackendDateOrDateTime(newDate));
    }
  }

  function handleChangeMonth(value: number) {
    if (value <= 12 && value >= 1) {
      const daysOfMonth = getDaysOfMonth(value);
      const safeDayValue = Math.min(dayValue ? dayValue : 1, daysOfMonth);
      const newDate = DateTime.local(2023, value, safeDayValue);
      onChange(luxonDateTimeToBackendDateOrDateTime(newDate));
    }
  }

  return (
    <Group className="DayInYearInput">
      <Select
        data={dayChoices}
        error={!!error && !dayChoice}
        name="day-in-year--day"
        placeholder="Tag"
        role="combobox"
        value={dayChoice}
        onChange={(newValue) => {
          if (newValue) {
            handleChangeDay(parseInt(newValue));
          }
        }}
      />
      <Select
        data={MONTH_CHOICES}
        error={!!error && !monthChoice}
        name="day-in-year--month"
        placeholder="Monat"
        role="combobox"
        value={monthChoice?.toString()}
        onChange={(newValue) => {
          if (newValue) {
            handleChangeMonth(parseInt(newValue));
          }
        }}
      />
    </Group>
  );
}

export { DayInYearInput, DayInYearInputProps };
